import React from 'react'
import { css } from '@emotion/core'
import ImagePicker from '../../components/PageAssembler/InnerComponents/ImagePicker/ImagePicker'
import Caption from '../../components/PageAssembler/InnerComponents/ImagePicker/Caption/Caption'

const frontCoverCSS = css`
  width: 100%;
  height: 100%;
`

const layoutCSS = css`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  width: 100%;
  height: 100%;
  gap: 20px;

  @media print {
    height: auto;
  }
`

const imageContainerStyles = css`
  height: 80%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const TemplateThree = ({ pageNumber, elements, isPrintView }) => {
  return (
    <>
      <Caption
        pageNumber={pageNumber}
        positionIndex={0}
        isHeading
        title={elements?.props?.title}
        memoryId={elements?.props?.memoryId}
        isPrintView={isPrintView}
      />

      <div css={imageContainerStyles}>
        <ImagePicker {...elements} {...elements?.props} pageNumber={pageNumber} noCaption isPrintView={isPrintView} />
      </div>
    </>
  )
}

const TemplateFour = ({ pageNumber, elements, isPrintView }) => {
  return (
    <>
      <Caption
        pageNumber={pageNumber}
        positionIndex={0}
        memoryId={elements?.props?.memoryId}
        title={elements?.props?.title}
        isHeading
        isPrintView={isPrintView}
      />

      <div css={imageContainerStyles}>
        <ImagePicker {...elements} {...elements?.props} pageNumber={pageNumber} isPrintView={isPrintView} />
      </div>
    </>
  )
}

export default function FrontCoverPage({ pageNumber, elements, isPrintView = false, templateId = '' }) {
  return (
    <div css={frontCoverCSS}>
      <div css={layoutCSS} data-testid={`front-cover-page-template-${templateId}`}>
        {templateId === 3 && <TemplateThree pageNumber={pageNumber} elements={elements} isPrintView={isPrintView} />}
        {templateId === 4 && <TemplateFour pageNumber={pageNumber} elements={elements} isPrintView={isPrintView} />}
      </div>
    </div>
  )
}
